import {useSelector as useReduxSelector} from 'react-redux';
import {IReduxRootState} from '@src/@interfaces';

export default function useSelector<T>(callable: (state: IReduxRootState) => T): T {
    return useReduxSelector(callable);
}
